// Featured-tab countdown tiers (GLOSSARY.md "Hero countdown", "Daily pick
// collection"): days at ≥ 24 h remaining, hours at ≥ 1 h, minutes below —
// every count rounded up. The rollover the Daily Picks countdown runs to
// also decides the last-minute refresh lock, so that predicate lives here
// beside it. All inputs are Shop server clock milliseconds.

const MINUTE_MS = 60_000
const HOUR_MS = 3_600_000
const DAY_MS = 86_400_000

export interface CountdownTier {
  count: number
  unit: 'day' | 'hour' | 'min'
}

export function resolveCountdownTier(remainingMs: number): CountdownTier {
  if (remainingMs >= DAY_MS) {
    return { count: Math.ceil(remainingMs / DAY_MS), unit: 'day' }
  }
  if (remainingMs >= HOUR_MS) {
    return { count: Math.ceil(remainingMs / HOUR_MS), unit: 'hour' }
  }
  return { count: Math.max(Math.ceil(remainingMs / MINUTE_MS), 0), unit: 'min' }
}

// The Daily Picks refresh moment: the server-side assortment rotates at UTC
// midnight, so the target always sits within the next 24 hours.
export function nextUtcMidnightMs(nowMs: number): number {
  return Math.floor(nowMs / DAY_MS) * DAY_MS + DAY_MS
}

// The last-minute refresh lock (GLOSSARY.md): the final minute before UTC
// midnight, during which the rollover is about to deliver the same rotation
// for free, so the paid refresh is withheld. A whole sixty seconds left is
// still time to buy — the lock starts inside that last minute — and it
// lifts of its own accord the moment the clock crosses midnight, because
// the target has moved a day on.
export function isRefreshLocked(nowMs: number): boolean {
  return nextUtcMidnightMs(nowMs) - nowMs < MINUTE_MS
}
